// All logos in one static image
const ALL_LOGOS_IMAGE = "https://customer-assets.emergentagent.com/job_peak-mastery/artifacts/ont6xb82_All%20logos.png";

export const LogoSection = () => {
  return (
    <section data-testid="logo-section" className="py-10 lg:py-14 bg-[#F4F1EC] border-y border-[#E6E1DA]">
      <div className="container-peak">
        <p className="text-center text-[10px] lg:text-[11px] tracking-[0.3em] uppercase text-[#5A6B7A] mb-6 lg:mb-8 font-['Syne']">
          Trusted by World-Class Organizations
        </p>

        <div className="max-w-4xl mx-auto">
          <img
            src={ALL_LOGOS_IMAGE}
            alt="Our clients - Stanford, GSK, Meta, Mindvalley, KPMG, Puma, Manchester United and more"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default LogoSection;
